// Layout
const dashboardLayout = () => import('@/layouts/DoctorLayout/DashboardLayout/dashboardLayout.vue')

const processing = () => import('./views/index')
/* const addProduct = () => import('./views/addProduct') */

// start Routes
export default [
  {
    path: '/doctor/processing',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'doctorProcessing',
      meta: {
        name: 'doctorProcessing',
        parentName: 'doctorProcessing',
        userType: '',
        permission: '',
        role: 'veterinary.doctor'
      },
      component: processing
    }]
  }
]
